export const question = [
    {
      id: 1,
      question: "Eligibility",
      answer: [
        {
          item: "Individuals and business",
        }
      ],
    },
    {
      id: 2,
      question: "Purpose",
      answer: [
        {
          item: "Loan against mortgage of immovable property located in; Urban/Semi Urban Rural Centres having developed & mortgage-able property other than farm-land.",
        },
      ],
    },
    {
      id: 3,
      question: "Security",
      answer: [
        {
          item: "Legal mortgage of property with forced sale value of 200% of the loan amount",
        },
      ],
    },
    {
      id: 4,
      question: "Customer’s Contribution",
      answer: [
        {
          item: "Repayment will be as per cash ﬂows of the business unit for the duration of the facility up to a maximum of 84 months",
        },
      ],
    }
  ];
    